module.exports = __webpack_public_path__ + "img/team_leaders.b35d51de.jpg";